import type { ReactNode} from 'react';
import type { PipelineType } from 'src/utils/enumerations';

import { useMemo, createContext } from 'react';

interface PipelineContextType {
  pipelineType: PipelineType;
}

export const PipelineContext = createContext<PipelineContextType | undefined>(undefined);

interface PipelineProviderProps {
  children: ReactNode;
  pipelineType: PipelineType;
}

export function PipelineProvider({ children, pipelineType }: PipelineProviderProps) {
  // Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(() => ({ pipelineType }), [pipelineType]);

  return <PipelineContext.Provider value={value}>{children}</PipelineContext.Provider>;
}

export default PipelineProvider;
